module.exports = __webpack_public_path__ + "img/gift.c8f79677.png";